import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { MainModule } from './features/spc/main.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { DatePipe } from '@angular/common';
import { AuthTokenInterceptor } from './core/adal/auth-token-interceptor';
import { PermissionGuard } from 'src/app/core/guard/permission.guard';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { Configuration, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { MatDialogModule } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

export function initializeMsalFactory(msalService: MsalService): () => Promise<void> {
  return () => msalService.instance.initialize();
}

export function initializeTranslateFactory(translateService: TranslateService): () => Promise<void> {
  return async () => {
    const defaultLanguageCode = 'en';
    let selectedLanguageCode = defaultLanguageCode;

    const savedLanguage = sessionStorage.getItem('languageMaster');
    if (savedLanguage) {
      try {
        const parsedLanguage = JSON.parse(savedLanguage);
        if (parsedLanguage?.code) {
          selectedLanguageCode = parsedLanguage.code;
        }
      } catch {
        selectedLanguageCode = defaultLanguageCode;
      }
    }

    translateService.setDefaultLang(defaultLanguageCode);

    try {
      await firstValueFrom(translateService.use(selectedLanguageCode));
    } catch {
      await firstValueFrom(translateService.use(defaultLanguageCode));
    }
  };
}
export const protectedResourceMap: [string, string[]][] = [
  ['https://graph.microsoft.com/v1.0/me', ['user.read']]
];

// const msalconfig = {
//   config: {
//     tenant: environment.tenant,
//     clientId: environment.clientId,
//     instance: environment.instance,
//     cacheLocation: environment.cacheLocation,
//     redirectUri: environment.redirectUri,
//     postLogoutRedirectUri: environment.postLogoutRedirectUri,
//     authority: environment.authority,
//     validateAuthority: environment.validateAuthority,
//     navigateToLoginRequestUrl: environment.navigateToLoginRequestUrl
//   }
// };

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: environment.config,
        cache: {
          cacheLocation: 'localStorage',
          // storeAuthStateInCookie: false, // set to true for IE 11
        },
        // system: {
        //   loggerOptions: {
        //     loggerCallback: (logLevel, message) => {
        //       // console.log(message);
        //     },
        //     logLevel: LogLevel.Info,
        //     piiLoggingEnabled: false
        //   }
        // }
      }),

      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ['user.read']
        }
      },

      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['user.read']]

        ])
      }
    ),
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MainModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    PopoverModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
        // useFactory: HttpLoaderFactory,
        // deps: [HttpClient]
      }
    }),
    NgxPermissionsModule.forRoot(),
    MatDialogModule
  ],
  providers: [
    // { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    DatePipe,
    PermissionGuard,
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: './assets/i18n/',
        suffix: '.json'
      }
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsalFactory,
      deps: [MsalService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslateFactory,
      deps: [TranslateService],
      multi: true
    },
    // Use AuthTokenInterceptor for all token injection and security headers
    // It has all the custom logic for MSAL v5 token renewal and API authentication
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    // Removed MsalInterceptor - AuthTokenInterceptor handles everything we need

  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader();
}
